import * as React from 'react';
import { connect } from 'react-redux';
import { Container, FormGroup, Input, Label, Table } from 'reactstrap';
import { bindActionCreators, Dispatch } from 'redux';

import Localization from '../../config/localization';

import { SECTOR_ID_GAS } from '../../constants/sectorId';

import * as BeneficiarySearchAction from '../../actions/BeneficiarySearch';

import * as AidsApi from '../../api/aids';
import * as PartnersApi from '../../api/partners';
import * as UtilApi from '../../api/util';

import ArrowRightSvg from '../../components/Svg/arrowRight';

import Notifications from '../../lib/notifications';
import { GetMonthFromSeason, GetName, ToNumber, ToString } from '../../lib/utils';

import BackButton from '../../components/BackButton';
import Client from '../../components/Client';
import Loader from '../../components/Loader';

import './BackOfficeAssociation.scss';
import { generatePath } from 'react-router';
import { Routes } from '../../constants/routes';
import { getQuantumAmount } from '../../lib/money';

class BackOfficeAssociation extends React.Component<BackOfficeAssociation.IProps, BackOfficeAssociation.IState> {
  state: BackOfficeAssociation.IState = {
    aids: undefined,
    partner: undefined,

    MONTHS: undefined,
    month: undefined,

    loading: false,
    loadingMessage: ''
  };

  componentDidMount() {
    $('#month').selectmenu({ change: this._setMonth });

    return Promise.all([this._getPartner(), this._getMonths()]);
  }

  renderAidRow = () => {
    return (
      this.state.aids &&
      this.state.aids.length &&
      this.state.aids.map(aid => (
        <tr key={aid.aidId}>
          <td>
            <h5 className="eon-title eon-middle-grey strong">{GetName({
              firstName: aid.firstName,
              lastName: aid.lastName
            })}</h5>
          </td>
          <td>
            <p className="eon-title eon-middle-grey">{aid.personalIdentificationNumber}</p>
          </td>
          <td>
            <h5
              className="eon-title eon-middle-grey strong">{getQuantumAmount(aid)}</h5>
          </td>
          <td>
            <p className="eon-title eon-middle-grey">{ToString(aid.approvalDocumentNo)}</p>
          </td>
          <td>
            <h5 className="eon-title eon-middle-grey">{ToNumber(aid.familyMembersNo)}</h5>
          </td>
          <td>
            <p className="eon-title eon-middle-grey">{ToNumber(aid.memberFamilyIncome)}</p>
          </td>
        </tr>
      ))
    );
  };

  renderTable = () => {
    if (!this.state.aids || !this.state.aids.length) {
      return (
        <p className="eon-title eon-middle-grey strong my-5 mx-4 text-nowrap">
          {Localization.formatString(
            Localization.backOfficeAssociationAidsNotExist,
            ToString(Localization.Months[GetMonthFromSeason(this.state.month)])
          )}
        </p>
      );
    }

    return (
      <Table className="my-5 text-left bg-eon-white" hover>
        <thead>
        <tr>
          <th className="align-top" scope="col">
            <p className="eon-title eon-red">{Localization.backOfficeAssociationTabelHeaderName}</p>
          </th>
          <th className="align-top" scope="col">
            <p className="eon-title eon-red mt-1">{Localization.backOfficeAssociationTabelHeaderCNP}</p>
          </th>
          <th className="align-top" scope="col">
            <p className="eon-title eon-red mt-1">{Localization.backOfficeAssociationTabelHeaderAmount}</p>
          </th>
          <th className="align-top" scope="col">
            <p className="eon-title eon-red mt-1">{Localization.backOfficeAssociationTabelHeaderApprovalDocumentNo}</p>
          </th>
          <th className="align-top" scope="col">
            <p className="eon-title eon-red mt-1">{Localization.backOfficeAssociationTabelHeaderMembersNo}</p>
          </th>
          <th className="align-top" scope="col">
            <p className="eon-title eon-red mt-1">{Localization.backOfficeAssociationTabelHeaderMemberFamilyIncome}</p>
          </th>
        </tr>
        </thead>
        <tbody>{this.renderAidRow()}</tbody>
      </Table>
    );
  };

  render() {
    return (
      <Container className="back-office-associations px-5 py-4 my-4 position-relative">
        <BackButton />

        <Loader loading={this.state.loading} loadingMessage={this.state.loadingMessage} />

        {this.state.partner && (
          <Client
            hideTitle
            partner={this.state.partner}
            isNaturalGas={this._isNaturalGas()}
            showUtilityType={true}
            extraClassName="client-card position-absolute"
          />
        )}

        <h4 className="mt-5 eon-title eon-red text-nowrap">{Localization.backOfficeAssociationTitle}</h4>
        <h6 className="mt-2 mb-4 eon-title eon-middle-grey">{Localization.backOfficeAssociationTips}</h6>

        <FormGroup className="my-4 w-25 d-inline-block remove-arrow">
          <Label className="text-nowrap" for="month">
            {Localization.backOfficeAssociationDropDownLabel}
          </Label>
          <fieldset className="eon-select large eon-red">
            <Input
              type="select"
              name="month"
              id="month"
              value={this.state.month}
              onChange={() => undefined}
              className="d-none eon-select large eon-red"
            >
              {this.state.MONTHS &&
              this.state.MONTHS.map(month => (
                <option value={month} key={month}>
                  {Localization.Months[GetMonthFromSeason(month)]}
                </option>
              ))}
            </Input>
          </fieldset>
        </FormGroup>

        <div className="my-4">
          <button className="eon-button bg-eon-red eon-white" onClick={this._goToComputation}>
            <span className="px-2 pl-3">
              {Localization.backOfficeAssociationButton}
              <ArrowRightSvg className="my-auto ml-3" />
            </span>
          </button>
        </div>

        {this.renderTable()}
      </Container>
    );
  }

  _getMonths = async () => {
    const response = await UtilApi.GetMonths();

    const MONTHS = response.data || [];

    await this.setState({ MONTHS, month: MONTHS[0] });

    await $('#month')
      .selectmenu()
      .selectmenu('refresh');

    return this._getAids();
  };

  _getPartner = async () => {
    try {
      await this.setState({ loading: true });

      const response = await PartnersApi.GetPartner({ search: this.props.match.params.consumptionPoint });

      await this.setState({ partner: (response.data && response.data[0]) || {} });

      return this.setState({ loading: false });
    } catch (error) {
      Notifications.error(error && error.message);

      return this.setState({ loading: false });
    }
  };

  _getAids = async () => {
    try {
      await this.setState({ loading: true });

      const response = await AidsApi.GetAid(this.props.match.params.consumptionPoint, { month: this.state.month });

      return this.setState({ aids: response.data || undefined, loading: false });
    } catch (error) {
      if (error.code !== '1015') {
        Notifications.error(error && error.message);
      }

      return this.setState({ loading: false, aids: undefined });
    }
  };

  _setMonth = (event: Event) => {
    event.preventDefault();

    const element = event.target || undefined;

    const month = (element ? ToString($(element).val()) : '') as keyof Month.IGetMonths;

    return this.setState({ month }, () => this._getAids());
  };

  _goToComputation = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();

    return this.props.history.push(generatePath(Routes.BackOfficeComputation, { ...this.props.match.params }));
  };

  _isNaturalGas = () =>
    !!(
      this.state.partner &&
      this.state.partner.consumptionPoints &&
      this.state.partner.consumptionPoints.length &&
      this.state.partner.consumptionPoints[0] &&
      this.state.partner.consumptionPoints[0].sectorId === SECTOR_ID_GAS
    );
}

const mapStateToProps = (state: General.Store) => ({ BeneficiarySearch: state.BeneficiarySearch });

const mapDispatchToProps = (dispatch: Dispatch) => ({ ...bindActionCreators({ ...BeneficiarySearchAction }, dispatch) });

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BackOfficeAssociation);
